import { render, staticRenderFns } from "./CaloriePlanner.vue?vue&type=template&id=3c919d87&scoped=true"
import script from "./CaloriePlanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./CaloriePlanner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./wellness-base.css?vue&type=style&index=0&id=3c919d87&prod&scoped=true&lang=css&external"
import style1 from "./CaloriePlanner.vue?vue&type=style&index=1&id=3c919d87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c919d87",
  null
  
)

export default component.exports